import React, { useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import yn from 'yn';
import { message, Modal, Tooltip } from 'antd-v5';
import { LoadingOutlined } from '@ant-design/icons';
import AddClientModal from '../../../../componentsV2/Layout/AddClientModal';
import '../../../Layout/chat/chatInbox.css';

const ClientHeader = props => {
  const [newClient, setNewClient] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const limitAssociateVisibility =
    yn(props.auth.merchantConfig.LIMIT_ASSOCIATE_VISIBILITY_ENABLED) && props.auth.role === 'ASSOCIATE';

  const handleError = useCallback(
    error => {
      if (error.status === 409 && error?.response?.data?.message === 'This client already has an assigned associate.') {
        setNewClient(false);
        const id = error?.response?.data?.data?.id;
        modal.info({
          title: 'Client already exists',
          content: 'This client already has an assigned associate.',
          onOk: () => (id && !limitAssociateVisibility ? props.getClientData(id) : {}),
        });
      } else {
        setNewClient(false);
        message.error(error?.response?.data?.message || 'An error occurred');
      }
    },
    [props.getClientData],
  );

  const handleSuccess = useCallback(
    data => {
      if (data?.isMergedClient) {
        modal.info({
          title: 'Client already exists',
          content: 'This client already exists and has been updated',
          onOk: () => props.getClientData(data.id),
        });
      } else {
        props.getClientData(data.id);
      }
    },
    [props.getClientData],
  );

  return (
    <div style={{ padding: '16px' }}>
      <div className="flex-row-spacebetween-nowrap" style={{ marginBottom: '16px' }}>
        <span className="list-panel-title">Clients</span>
        <div className="flex-row-nospacebetween-nowrap" style={{ gap: '8px' }}>
          {props.auth.role !== 'ASSOCIATE' && (
            <Tooltip title="Export Client List" placement="bottom">
              <div
                className="list-header-icon-btn"
                onClick={() => props.getCSVData()}
                onKeyDown={() => props.getCSVData()}
                role="button"
                tabIndex={0}
              >
                <FontAwesomeIcon
                  icon={['far', 'file-alt']}
                  className="fs-16"
                />
              </div>
            </Tooltip>
          )}
          <Tooltip title="Client Filters" placement="bottom">
            <div
              className="list-header-icon-btn"
              onClick={() => props.setClientFilterOpen(!props.clientFilterOpen)}
              onKeyDown={() => props.setClientFilterOpen(!props.clientFilterOpen)}
              role="button"
              tabIndex={0}
            >
              {!props.hasFilter ? (
                <FontAwesomeIcon
                  icon={['far', 'filter']}
                  className="fs-16"
                />
              ) : (
                <img
                  src="https://dashboard-v2-images.s3.amazonaws.com/FilterActive.svg"
                  alt="non-default filter icon"
                  style={{ height: '16px', width: '16px' }}
                />
              )}
            </div>
          </Tooltip>
          <Tooltip title="Add Client" placement="bottom">
            <div
              className="list-header-icon-btn"
              data-testid="clients__list--add-button"
              onClick={props?.auth?.stores?.length > 0 ? () => setNewClient(true) : undefined}
              onKeyDown={props?.auth?.stores?.length > 0 ? () => setNewClient(true) : undefined}
              role="button"
              tabIndex={0}
              style={{
                cursor: props?.auth?.stores?.length > 0 ? 'pointer' : 'not-allowed',
                opacity: props?.auth?.stores?.length > 0 ? 1 : 0.5,
              }}
            >
              <FontAwesomeIcon
                icon="fa-regular fa-user-plus"
                className="fs-16"
              />
            </div>
          </Tooltip>
        </div>
      </div>
      <div style={{ position: 'relative' }}>
        <input
          className="inboxSearch2"
          id="client-search"
          placeholder="Search by name, phone, email"
          onChange={e => props.setSearch(e.target.value)}
          value={props.search}
        />
        {props?.loadingSearch && (
          <LoadingOutlined style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#818181' }} />
        )}
      </div>
      {props?.auth?.stores?.length > 0 && newClient && (
        <AddClientModal
          open={newClient}
          setOpen={setNewClient}
          initialValues={{
            storeId: props.auth.stores.filter(st => st.id !== 0).length
              ? props.auth.stores.filter(st => st.id !== 0)[0].id
              : null,
          }}
          onSuccess={data => handleSuccess(data)}
          onError={error => handleError(error)}
        />
      )}
      {contextHolder}
    </div>
  );
};

export default ClientHeader;
